var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgTrx = function SvgTrx(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FF060A"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M16.157 8.032c-.612-.565-1.459-1.427-2.148-2.04l-.041-.028a.78.78 0 0 0-.226-.126c-1.663-.31-9.4-1.757-9.55-1.738a.286.286 0 0 0-.119.045l-.039.03a.455.455 0 0 0-.106.172l-.01.026V4.54c.87 2.426 4.31 10.37 4.987 12.235.041.126.118.367.263.38h.033c.077 0 .408-.437.408-.437s5.907-7.164 6.505-7.927c.077-.094.145-.195.204-.302a.492.492 0 0 0-.162-.457Zm-5.033.835 2.522-2.091 1.478 1.363-4 .728Zm-.979-.137-4.34-3.557 7.023 1.295-2.683 2.262Zm.392.932 4.443-.716-5.08 6.12.637-5.404ZM5.215 5.528l4.567 3.875-.66 5.667-3.907-9.542Z",
    fill: "white"
  })));
};
export default SvgTrx;